import React from 'react';
import { render } from 'react-dom';
import './index.scss';
import App from './Containers/App';
import registerServiceWorker from './registerServiceWorker';

registerServiceWorker();
render(<App />, document.getElementById('root'));
